import {SENDING_PRESENTATION_REQUEST, FECTH_PRESENTATION_SUCCESS, FECTH_PRESENTATION_FAILURE, MQTT_NEW_STATTION_STATE_RECEIVE, FILTER_PRESENTATION_GROUPS} from '../actions/constants'

let initialState = {
  stations: [],
  filterGroups: [],
  fetching: false,
  error: ''
}

const presentation = (state = initialState, action) => {
  switch (action.type) {
    case SENDING_PRESENTATION_REQUEST:
      return {
        ...state,
        fetching: action.sending
      }
    case FECTH_PRESENTATION_SUCCESS:
      return {
        ...state,
        stations: action.stations
      }
    case MQTT_NEW_STATTION_STATE_RECEIVE:
      return {
        ...state,
        stations: action.stations
      }
    case FECTH_PRESENTATION_FAILURE:
      return {
        ...state,
        error: action.error
      }
    case FILTER_PRESENTATION_GROUPS:
      return {
        ...state,
        filterGroups: action.groups
      }
    default:
      return state
  }
}
export default presentation



// WEBPACK FOOTER //
// ./src/reducers/presentation.js